// @ts-nocheck

export default defineNuxtPlugin(() => {
  (function (w: any, d: any, t: any) {
    w.TiktokAnalyticsObject = t;
    const ttq = (w[t] = w[t] || []);
    ttq.methods = [
      'page',
      'track',
      'identify',
      'instances',
      'debug',
      'on',
      'off',
      'once',
      'ready',
      'alias',
      'group',
      'enableCookie',
      'disableCookie',
    ];
    ttq.setAndDefer = function (t: any, e: any) {
      t[e] = function () {
        t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
      };
    };
    for (let i = 0; i < ttq.methods.length; i++) {
      ttq.setAndDefer(ttq, ttq.methods[i]);
    }
    ttq.instance = function (t: any) {
      const e = ttq._i[t] || [];
      for (let i = 0; i < ttq.methods.length; i++) {
        ttq.setAndDefer(e, ttq.methods[i]);
      }
      return e;
    };
    ttq.load = function (e: string, n: any) {
      const i = 'https://analytics.tiktok.com/i18n/pixel/events.js';
      ttq._i = ttq._i || {};
      ttq._i[e] = [];
      ttq._i[e]._u = i;
      ttq._t = ttq._t || {};
      ttq._t[e] = +new Date();
      ttq._o = ttq._o || {};
      ttq._o[e] = n || {};
      const o = d.createElement('script');
      o.type = 'text/javascript';
      o.async = true;
      o.src = `${i}?sdkid=${e}&lib=${t}`;
      const a = d.getElementsByTagName('script')[0];
      a.parentNode.insertBefore(o, a);
    };

    ttq.load('D0I846BC77UDCRP67KK0');
    ttq.page();
  })(window, document, 'ttq');

  const track = (eventName: string, eventData?: Record<string, any>): void => {
    if (import.meta.client && window.ttq && typeof window.ttq.track === 'function') {
      window.ttq.track(eventName, eventData || {});
    } else {
      console.warn('[TikTokPixel] ttq.track not initialized.');
    }
  };

  return {
    provide: {
      ttTrack: track,
    },
  };
});
